// components/indicatorChart.jsx
import React, { useEffect, useRef, useState } from 'react';
import './index.css';
import { widget } from '../../charting_library';
import Datafeed from '../../mydatafeed/datafeed';
import { API_URL } from '../../api-config.js';
import IndicatorAssistant from './VirtualAssistant/IndicatorAssistant.jsx';

export const TVIndicator = () => {
  const [tvWidget, setTvWidget] = useState(null);
  const [isFullscreen, setIsFullscreen] = useState(window.innerWidth < 508);
  const [isLoading, setIsLoading] = useState(false);
  const [notice, setNotice] = useState("");
  const chartContainerRef = useRef();

  // helpers puros
  const dayBoundsMs = (isoDate) => {
    const [y, m, d] = isoDate.split('-').map(Number);
    const start = new Date(y, m - 1, d, 0, 0, 0, 0);
    const end   = new Date(y, m - 1, d + 1, 0, 0, 0, 0);
    return [start.getTime(), end.getTime() - 1];
  };
  const showNotice = (msg) => {
    setNotice(msg);
    setTimeout(() => setNotice(""), 3000);
  };

  useEffect(() => {
    const handleResize = () => setIsFullscreen(window.innerWidth < 500);
    handleResize();
    window.addEventListener('resize', handleResize);

    const tvw = new widget({
      symbol: 'USDCLP',
      datafeed: Datafeed,
      interval: '5',
      container: chartContainerRef.current,
      library_path: '/charting_library/',
      theme: "dark",
      style: "1",
      timezone: "America/Santiago",
      disabled_features: ['use_localstorage_for_settings', 'header_saveload'],
      enabled_features: ['study_templates'],
      fullscreen: isFullscreen,
      autosize: false,
      height: '85%',
      width: '95%',
      supported_resolutions: ['5','30','1H']
    });
    setTvWidget(tvw);

    tvw.onChartReady(() => {
      const dayRangeSec = (isoDate) => {
        const [fromMs, toMs] = dayBoundsMs(isoDate);
        return [Math.floor(fromMs / 1000), Math.floor(toMs / 1000)];
      };
      tvw.goToDay = (isoDate) => {
        const [from, to] = dayRangeSec(isoDate);
        const chart = tvw.activeChart();
        chart.setVisibleRange({ from, to }, { applyDefaultRightMargin: false });
      };

      // 👇 Debug del rango visible (útil para cruzar con backend)
      const chart = tvw.activeChart();
      chart.onVisibleRangeChanged(({ from, to }) => {
        console.log('[TV:rangeChanged]', {
          from,
          to,
          fromISO: new Date(from*1000).toISOString(),
          toISO: new Date(to*1000).toISOString()
        });
      });
    });

    window.removeEventListener('resize', handleResize);
  }, [isFullscreen]);

  const askMCPAndLoad = async (text) => {
    if (!tvWidget) return "El gráfico aún no está listo. Intenta de nuevo en un momento.";
    setIsLoading(true);
    try {
      const templateJson = await new Promise((resolve) => {
        try { tvWidget.save(resolve); } catch { resolve(null); }
      });

      const resp = await fetch(`${API_URL}/trading-api/mcp/consulta`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ message: text, template: templateJson }),
      });
      if (!resp.ok) {
        const err = await resp.json().catch(() => ({}));
        throw new Error(err.detail || "Error en MCP /consulta");
      }
      const data = await resp.json();
      console.log("Respuesta MCP:", data);

      // Carga chart si viene
      if (data.chart) {
        try { tvWidget.load(JSON.parse(data.chart)); }
        catch { console.warn("No se pudo parsear chart del MCP."); }
      }

      // ✅ Si vienen velas históricas, reemplaza todo lo que se ve
      if (Array.isArray(data.minute_candles) && data.minute_candles.length > 0) {
        Datafeed.replaceExternalBars(data.minute_candles);

        const chart = tvWidget.activeChart();
        const currentRes = chart.resolution();
        chart.setSymbol('USDCLP', () => {
          // 2) devuelve la resolución
          chart.setResolution(currentRes, () => {
            if (data.fecha && tvWidget.goToDay) tvWidget.goToDay(data.fecha);
          });
        });
      } else if (data.fecha) {
        showNotice(`No hay datos para ${data.fecha}.`);
      }

      return data.DirectMSG || data.msg || "Solicitud procesada.";
    } catch (e) {
      console.error(e);
      return `Error: ${(e && e.message) || "No se pudo procesar la solicitud."}`;
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {isLoading && <div className="loading-overlay"><div className="loading-spinner" /></div>}
      {notice && <div className="tv-toast">{notice}</div>}
      <div ref={chartContainerRef} className={'TVIndicator'} />
      <IndicatorAssistant onSubmit={askMCPAndLoad} />
    </>
  );
};
